import { useEffect, useMemo, useState } from "react";
import { useFieldArray } from "react-hook-form";
import { CheckBox } from "../../components/reactHookFormFields/checkbox";
import { useGroupChatContext } from "../../context/groupchatContext";
import { useGetPatientContactQuery } from "../../services/vezoService";


export const PatientContact = ({formHandler, contactToBeSelected}) => {

    const groupChatContext = useGroupChatContext();
    const { authData, selectedChat } = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat,
    }));

    const [patientContact, setPatientContact] = useState([])

    const { fields: contacts, replace } = useFieldArray({
        control: formHandler.control, 
        name: 'patientContact',
    });

    const {data: patContact} = useGetPatientContactQuery({pid: selectedChat.pid}, {skip: !authData?.is_provider })

    useEffect(()=>{
        if(contactToBeSelected?.length){
            let updatedContacts = []
            patContact.map((contact)=>{
                const foundContact = contactToBeSelected.find(item => (item.email == contact.email && item.phone == contact.phone)) 
                if(foundContact){
                    updatedContacts.push({...foundContact, cell_checked: foundContact.cell_checked == 1 ? true : false, email_checked: foundContact.email_checked == 1 ? true : false})
                }
                else{
                    updatedContacts.push(contact)
                }
            })
            
            setPatientContact(updatedContacts)

            // Update field array to sync with `react-hook-form`
            replace(updatedContacts);
        }
    }, [contactToBeSelected, patContact])


    return (
        <>
            <strong>Select patient contacts to be invited </strong>(For Vezo session)
            {!patientContact?.length ?
                <div className="mt-2">Contacts not found</div>
                :
                <div>
                    {patientContact.map((contact, index)=>{
                        return(
                            <div>
                                <label>{contact.name} <span className="uppercase"> {contact.name && contact.type ? '-' : null} {contact.type} </span></label>
                                {contact.phone ?
                                    <CheckBox
                                        title={contact.phone}
                                        name={`patientContact[${index}].cell_checked`}
                                        control={formHandler.control}
                                    />
                                : null}
                                {contact.email ?
                                    <CheckBox
                                        title={contact.email}
                                        name={`patientContact[${index}].email_checked`}
                                        control={formHandler.control}
                                    />
                                    : null
                                }
                            </div>
                        )
                    })}
                </div>
            }
        </>
    )
}